export const situacaoConviteEnum = {
  ENVIADO: 'ENVIADO',
  ACEITO: 'ACEITO',
  RECUSADO: 'RECUSADO',
  EXPIRADO: 'EXPIRADO'
};
